
import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import Editor from '@/components/Editor/Editor.vue'
import PhoneInput from '@/_components/input/phone/phone.vue'

@Component({
    components: { Editor, PhoneInput },
    mixins: [ProjectMixin],
})
export default class EditContact extends Mixins<MixinInterface>(ProjectMixin) {
    add = true
    valid = false

    get contactId() {
        return this.$route.params.hseContactId
    }

    // CONTACT
    get contactBase() {
        return this.contactId ? this.$store.getters.hseContact(this.contactId) : null
    }

    contact: any = null

    initializeContact() {
        this.contact = JSON.parse(JSON.stringify(this.contactBase))
    }

    get stagedChanges() {
        let diff = this.difference(this.contact, this.contactBase)

        let result = {
            ...(diff.attributes && {
                attributes: {
                    ...(diff.attributes.name && { name: diff.attributes.name }),
                    ...(diff.attributes.hasOwnProperty('description') && {
                        description: diff.attributes.description,
                    }),
                    ...(diff.attributes.phoneNumber && {
                        phoneNumber: diff.attributes.phoneNumber,
                    }),
                    ...(diff.attributes.hasOwnProperty('isPublic') && {
                        isPublic: diff.attributes.isPublic,
                    }),
                },
            }),
        }
        this.isObjectEmpty(result.attributes) ? delete result.attributes : null
        return result
    }

    get hasStagedChanges() {
        return !this.isObjectEmpty(this.stagedChanges)
    }

    // PATCH
    loading = false
    async patch() {
        let hasError = false
        this.loading = true

        if (this.hasStagedChanges && this.valid) {
            let params = {
                updatedAt: this.$store.getters.hseContact(this.contact.id).attributes.updatedAt,
                data: {
                    id: this.contact.id,
                    type: this.contact.type,
                    ...this.stagedChanges,
                },
            }
            let res = await this.patchHSEContact(params).catch((error: any) => {
                hasError = true
                this.loading = false
                this.$store.commit('setErrorSnackBar', {
                    data: error.data.response.data.errors,
                    text: this.$t('vbit_error.default_header'),
                    url: `PATCH: ${this.url_project}/hseContacts/${this.contact.id}`,
                })
            })
            if (hasError || !res) return
            this.contact = JSON.parse(JSON.stringify(res))
        }

        this.close()

        this.loading = false
    }

    // NAME
    nameRules = [(v: any) => !!v || this.getTranslation('fe_hse_module.error_name_required')]

    // DESCRIPTION
    tools = [
        'header',
        'linkTool',
        'list',
        'embed',
        'quote',
        'table',
        'delimiter',
        'Marker',
        'underline',
    ]

    setDescription(data: any) {
        this.isEqualRichText(data, this.contactBase.attributes.description)
            ? (this.contact.attributes.description = this.contactBase.attributes.description)
            : (this.contact.attributes.description = data)
    }

    get isProject() {
        return this.$route.params.type != 'p'
    }

    get projectId() {
        return this.$route.params.type == 'p' ? this.$route.params.id : this.$route.query.projectId
    }

    // LIFE CYCLE
    created() {
        this.initializeContact()
    }

    close() {
        this.$router.push({
            name: 'hse-contacts-settings',
            params: { projectId: this.$route.params.projectId },
        })
    }
}
